var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8, _stop9, _stop10, _stop11, _stop12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgBulb(props) {
  const _id6 = useUniqueInlineId();
  const _id5 = useUniqueInlineId();
  const _id4 = useUniqueInlineId();
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.917 8.907H.75",
    stroke: `url(#${_id})`,
    strokeWidth: 1.078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 8.907h1.167",
    stroke: `url(#${_id2})`,
    strokeWidth: 1.078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87 4.37l.826-.825",
    stroke: `url(#${_id3})`,
    strokeWidth: 1.078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.796 4.37l-.825-.825",
    stroke: `url(#${_id4})`,
    strokeWidth: 1.078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.334 2.49V1.324",
    stroke: `url(#${_id5})`,
    strokeWidth: 1.078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.334 4.532a4.375 4.375 0 00-1.75 8.386v1.822c0 .322.26.584.583.584H9.5a.583.583 0 00.584-.584v-1.822a4.376 4.376 0 00-1.75-8.386z",
    fill: `url(#${_id6})`
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 1.14,
    y1: 8.73,
    x2: 0.67,
    y2: 9.591,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6700"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 15.14,
    y1: 8.73,
    x2: 14.67,
    y2: 9.591,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6700"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id3,
    x1: 13.146,
    y1: 3.399,
    x2: 12.729,
    y2: 4.055,
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6700"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id4,
    x1: 3.247,
    y1: 3.399,
    x2: 2.829,
    y2: 4.055,
    gradientUnits: "userSpaceOnUse"
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900"
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6700"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id5,
    x1: 8.667,
    y1: 1.117,
    x2: 8.044,
    y2: 1.958,
    gradientUnits: "userSpaceOnUse"
  }, _stop9 || (_stop9 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900"
  })), _stop10 || (_stop10 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6700"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id6,
    x1: 6.879,
    y1: 2.62,
    x2: 1.026,
    y2: 10.088,
    gradientUnits: "userSpaceOnUse"
  }, _stop11 || (_stop11 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900"
  })), _stop12 || (_stop12 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6700"
  })))));
}
export default SvgBulb;